<template>
    <td>
        <i v-if="comment" v-popover="popover" class="fa-regular fa-comment" />
    </td>
</template>

<script>
import { nl2br } from 'larasnap/support';

export default {
    props: {
        comment: String,
        username: String,
    },
    computed: {
        popover() {
            const content = [
                `<div class="${this.$style.comment}">
                    ${nl2br(this.comment)}
                </div>`,
            ];

            if (this.effectiveUsername) {
                content.push(
                    `<div class="${this.$style.username}">- ${this.effectiveUsername}</div>`,
                );
            }

            return content.join('');
        },
        effectiveUsername() {
            if (this.comment.includes('has been blanket approved')) {
                return null;
            } else {
                return this.username;
            }
        },
    },
};
</script>

<style lang="scss" module>
.comment {
    font-style: italic;
    font-size: 1.1em;
}
.username {
    font-weight: bold;
    width: 100%;
    text-align: right;
}
</style>
